import { Component, ReactNode } from 'react'

import ButtonGorup from '../../libs/ui/buttons/ButtonGroup'
import RadioButton from '../../libs/ui/buttons/RadioButton'

export type ProfessionistaType = 'studioProfessionale' |  'singoloProfessionista'  | undefined

export function getProfessionistaValue (bol: boolean | undefined) : ProfessionistaType {
    return (bol === undefined)
            ? undefined
            : ((bol) ? 'studioProfessionale' : 'singoloProfessionista')
}

export function getBoolean (siNo: ProfessionistaType) {
    return (siNo === undefined)
        ? undefined
        : (siNo === 'studioProfessionale')
}

interface ProfessionistaProps {
    key: string | undefined
    value: ProfessionistaType
    error: string | undefined
    callback?: Function
}

interface ProfessionistaState {
    forceRedraw: boolean
}

class TipoProfessionista extends Component<ProfessionistaProps, ProfessionistaState> {
    
    constructor (props: any) {
        super(props)

        this.state = {
            forceRedraw: false
        }

        this.updateValue = this.updateValue.bind(this)
    }

    componentDidUpdate(prevProps: Readonly<ProfessionistaProps>, prevState: Readonly<ProfessionistaState>, snapshot?: any): void {
        if (prevProps.value !== this.props.value) {
            this.setState({ forceRedraw: !this.state.forceRedraw })
        }
    }
    

    render(): ReactNode {
        const keyStudio = 'studioProfessionale'
        const keySingolo = 'singoloProfessionista'

        return (
            <>
                <ButtonGorup 
                    id='tipo_professionista'
                    label='Operi come studio professionale o professionista singolo?'
                    value={this.props.value}
                    callback={this.updateValue}
                    error={this.props.error}
                >
                    <RadioButton 
                        key={keyStudio} id={keyStudio} name={keyStudio} 
                        label='Studio Professionale'
                        value={keyStudio}
                        activeId={ this.props.value }
                    />
                    <RadioButton 
                        key={keySingolo} id={keySingolo} name={keySingolo} 
                        label='Singolo Professionista'
                        value={keySingolo}
                        activeId={ this.props.value }
                    />
                    
                </ButtonGorup>
            </>
        )
    }

    private updateValue (val: ProfessionistaType) {
        if (this.props.callback) {
            this.props.callback (
                getBoolean( val )
            )
        }
    }
}

export default TipoProfessionista